import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import DropDownNav from "components/Drop-down-nav";
import { Nav } from "@/types/nav";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const nav: Array<Nav> = [
  {
    value: "主页",
    link: "./#/",
    outside: true,
    icon: "",
    type: "normal",
    list: [],
  },
  {
    value: "名人堂",
    // link: "./#/hof",
    link: "./#/hof",
    outside: true,
    icon: "",
    type: "normal",
    list: [],
  },
  {
    value: "官方论坛",
    link: "https://www.daoyu8.com/#/circle?circleId=854690",
    outside: true,
    icon: "",
    type: "normal",
    list: [],
  },
  {
    value: "",
    icon: "",
    link: "https://mxd.web.sdo.com/web8/index.html",
    outside: false,
    type: "logo",
    list: [],
  },
  {
    value: "投稿说明",
    link: "./#/Article?ArticleID=345601",
    outside: false,
    type: "normal",
    icon: "",
    list: [],
  },
  {
    value: "次元站",
    link: "./#/Article?ArticleID=345602",
    outside: false,
    type: "normal",
    icon: "",
    list: [],
  },
  {
    value: "导航",
    link: "",
    outside: false,
    type: "list",
    icon: "",
    list: [
      {
        label: "主页",
        link: "Home",
      },
      {
        label: "目录",
        link: "Catalog",
      },
      {
        label: "职业",
        // link: "construction",
        link: "Classes",
      },
      {
        label: "搜索",
        link: "Search",
      },
    ],
  },
];

function navigate(item: Nav) {
  // if (item.type != 'normal' || item.type != 'logo') {
  //   return false
  // }

  // location.href = item.link

  if (item.outside) {
    window.open(item.link);
  } else {
    location.href = item.link;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nav, (item, index) => {
        return _createElementVNode("li", {
          key: index,
          class: "item"
        }, [
          (item.type == 'normal')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nav-link",
                onClick: ($event: any) => (navigate(item))
              }, _toDisplayString(item.value), 9, _hoisted_3))
            : _createCommentVNode("", true),
          (item.type == 'logo')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "nav-logo",
                onClick: ($event: any) => (navigate(item))
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          (item.type == 'list')
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(DropDownNav)), {
                key: 2,
                data: item
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ])
  ]))
}
}

})